import { render } from "./MathQuizGame.vue?vue&type=template&id=65ec60be&scoped=true"
import script from "./MathQuizGame.vue?vue&type=script&lang=js"
export * from "./MathQuizGame.vue?vue&type=script&lang=js"

import "./MathQuizGame.vue?vue&type=style&index=0&id=65ec60be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ec60be"]])

export default __exports__